import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
  name: 'user',
  initialState: {
    user: localStorage.getItem('user')
      ? JSON.parse(localStorage.getItem('user'))
      : undefined,
    status: 'idle',
  },
  reducers: {
    login: (state, action) => {
      state.user = action.payload.user;
      localStorage.setItem('user', JSON.stringify(action.payload.user));
      localStorage.setItem('token', action.payload.token);
    },
    logout: (state) => {
      state.user = undefined;
      localStorage.removeItem('user');
      localStorage.removeItem('token');
    },
  },
});
export const { login, logout } = userSlice.actions;
export default userSlice.reducer;
